module.exports = __webpack_public_path__ + "img/banner2.3ee1c712.jpg";